window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.gameRepo = function () {
    var urlGame = 'api/game';
    var urlGames = 'api/games?c=' + casino.config.guiCacheVerzija;

    // radimo cache igri, jednom je dosta
    var igrePromise = null;

    var list = function () {
        if (!igrePromise)
            igrePromise = fetch(urlGames)
                .then(casino.repos.base.checkResponse)
                .then(function (response) {
                    return response.json();
                })
                .catch(casino.repos.base.handleNetworkException);

        return igrePromise;
    };




    var get = function (id, forFun, selectedTab = "", from = "") {

        var url = casino.utils.getGameBackUrl(id, selectedTab, from);

        return fetch(urlGame +
            casino.repos.base.serializeGetParams({
                id: id,
                forFun: forFun,
                backUrl: url
            }), {
            credentials: repos.base.credentials,
            headers: repos.base.headers()
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };


    return {
        list: list,
        get: get
    }

}();